namespace $ {

	$mol_style_define( $shm_codex_app, {
		Sessions_pick: {
			maxWidth: '16rem',
		},
		Sessions_current: {
			maxWidth: '12rem',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
		},
		Sessions_panel: {
			flex: { direction: 'column', grow: 0, shrink: 1 },
			padding: $mol_gap.block,
			gap: $mol_gap.block,
			width: '24rem',
			maxWidth: 'calc(100vw - 2rem)' as any,
			minHeight: 0,
			maxHeight: '70vh',
		},
		New_session_bar: {
			width: '100%',
			gap: 0,
		},
		New_session_title: {
			flex: { grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
		},
		Create: {
			justifyContent: 'center',
		},
		Search: {
			width: '100%',
			height: '3rem',
			flex: { grow: 0, shrink: 0 },
		},
		Sessions: {
			flex: { direction: 'column', grow: 0, shrink: 1 },
			minHeight: 0,
			maxHeight: '28rem',
			overflow: 'auto',
			gap: $mol_gap.space,
		},
		No_session: {
			padding: $mol_gap.block,
			color: $mol_theme.shade,
		},
		Session: {
			justifyContent: 'flex-start',
			textAlign: 'left',
			whiteSpace: 'normal',
			wordBreak: 'break-word',
			'[current]': {
				true: {
					color: $mol_theme.current,
				},
			},
		},
		Chat_page: {
			flex: { basis: '56rem', grow: 1, shrink: 1 },
			minWidth: '34rem',
			Tools: {
				align: { items: 'center' },
				gap: $mol_gap.text,
			},
			Body_content: {
				flex: { grow: 1, shrink: 1, basis: 0 },
				height: '100%',
				maxHeight: '100%',
				padding: 0,
				paddingLeft: '0.5rem',
			},
		},
		Chat_provider: {
			maxWidth: '12rem',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
			color: $mol_theme.shade,
			font: { size: '0.75rem' },
		},
		Chat_status: {
			color: $mol_theme.shade,
			font: { size: '0.8rem' },
			'[busy]': {
				true: {
					color: $mol_theme.current,
				},
			},
		},
		Goal: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			minWidth: '24rem',
			maxWidth: '32rem',
		},
		Goal_head: {
			justifyContent: 'space-between',
			alignItems: 'center',
			gap: $mol_gap.text,
		},
		Goal_title: {
			font: { weight: 'bold' },
		},
		Goal_status: {
			color: $mol_theme.shade,
			font: { size: '0.8rem' },
		},
		Goal_input: {
			minHeight: '7rem',
		},
		Goal_actions: {
			gap: 0,
		},
		Messages_box: {
			position: 'relative',
			flex: { grow: 1, shrink: 1, basis: 0 },
			minHeight: '18rem',
			minWidth: 0,
		},
		Messages: {
			flex: { direction: 'column', grow: 1, shrink: 1, basis: 0 },
			width: '100%',
			height: '100%',
			minHeight: 0,
			overflow: 'auto',
			gap: $mol_gap.text,
			padding: { right: $mol_gap.text, bottom: $mol_gap.block },
		},
		Message: {
			flex: { direction: 'column', shrink: 0 },
			gap: $mol_gap.text,
			padding: { left: $mol_gap.block, right: $mol_gap.block, top: $mol_gap.text, bottom: $mol_gap.block },
			border: { radius: $mol_gap.round },
			background: { color: $mol_theme.card },
		},
		Message_head: {
			color: $mol_theme.shade,
			font: { size: '0.8rem' },
			gap: $mol_gap.text,
			align: { items: 'center' },
		},
		Message_time: {
			margin: { left: 'auto' },
		},
		Message_text_box: {
			flex: { shrink: 0 },
			margin: '-0.75rem',
			minHeight: 0,
		},
		Prompt: {
			height: '7rem',
			flex: { grow: 1, shrink: 1, basis: 0 },
			minWidth: 0,
		},
		Send: {
			height: '1rem',
			margin: { right: '2.5rem' },
		},
		'@media': {
			'(max-width: 640px)': {
				Chat_page: {
					width: '100%',
					minWidth: '100%',
					flex: { basis: '100%', grow: 1, shrink: 1 },
					Body_content: {
						paddingLeft: '0',
					},
				},
				Goal: {
					width: '100%',
					minWidth: 0,
					maxWidth: '100vw',
				},
				Send: {
					margin: 0,
				},
			},
		},
	} )

}
